'use client';

import { useEffect } from 'react';
import { StructuredData as StructuredDataType } from '@/types/structuredData';

interface StructuredDataClientProps {
  data: StructuredDataType | StructuredDataType[];
}

export const StructuredDataClient = ({ data }: StructuredDataClientProps) => {
  useEffect(() => {
    const jsonLd = Array.isArray(data) ? data : [data];
    
    const existingScripts = document.querySelectorAll('script[data-structured-data="true"]');
    existingScripts.forEach((script) => script.remove());

    jsonLd.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-structured-data', 'true');
      script.id = `structured-data-${index}`;
      script.textContent = JSON.stringify(schema, null, 0);
      document.head.appendChild(script);
    });

    return () => {
      const scriptsToRemove = document.querySelectorAll('script[data-structured-data="true"]');
      scriptsToRemove.forEach((script) => script.remove());
    };
  }, [data]);

  return null;
};
